import React, { useEffect, useState, createContext, useContext } from 'react';
export interface User {
  id: string;
  name: string;
  email: string;
  role: 'user' | 'astrologer' | 'admin';
}
interface UserContextType {
  user: User | null;
  isLoggedIn: boolean;
  login: (email: string, password?: string) => void;
  register: (name: string, email: string, password?: string) => void;
  logout: () => void;
}
const USER_STORAGE_KEY = 'astroguide_user';
const UserContext = createContext<UserContextType | undefined>(undefined);
export function UserProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(() => {
    try {
      const stored = localStorage.getItem(USER_STORAGE_KEY);
      if (stored) return JSON.parse(stored) as User;
    } catch {}
    return null;
  });
  useEffect(() => {
    if (user) {
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(USER_STORAGE_KEY);
    }
  }, [user]);
  const login = (email: string) => {
    setUser({
      id: 'user-' + Date.now(),
      name: email.split('@')[0],
      email,
      role: email.includes('admin') ? 'admin' : email.includes('astro') ? 'astrologer' : 'user'
    });
  };
  const register = (name: string, email: string) => {
    setUser({
      id: 'user-' + Date.now(),
      name,
      email,
      role: 'user'
    });
  };
  const logout = () => {
    setUser(null);
  };
  return <UserContext.Provider value={{
    user,
    isLoggedIn: !!user,
    login,
    register,
    logout
  }} data-id="element-16045">
      {children}
    </UserContext.Provider>;
}
export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}